import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// It is used to define our endpoints and allow to create the API slice
export const integratedApi = createApi({
  // The unique key that defines where the Redux store will store our cache.
  reducerPath: 'integratedApi',

  // The base query to request data.
  // RTK Query ships with fetchBaseQuery, which is a lightweight fetch wrapper that automatically handles request headers and response parsing in a manner similar to common libraries like axios.
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['Integrated'],
  // keepUnusedDataFor: 1,
  refetchOnMountOrArgChange: 1,
  // The set of operations that we want to perform against the server.
  endpoints: (builder) => ({


    integrated: builder.mutation({
      query: (newPost) => ({
        url: `integrated`,
        method: 'POST',
        body: newPost,
        headers: {
          'X-User-Token': localStorage.getItem('userToken'),
          'X-User-Id': localStorage.getItem('userId'),
          'X-User-Role': localStorage.getItem('userRole'),
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Integrated'],
    }),




  }),

})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const { useIntegratedMutation } = integratedApi